import clarity from '@microsoft/clarity'

const CLARITY_PROJECT_ID = import.meta.env.VITE_CLARITY_PROJECT_ID

export function initClarity() {
  if (CLARITY_PROJECT_ID) {
    clarity.init(CLARITY_PROJECT_ID)
  }
}